var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-table" },
    [
      _c(
        "ma-modal",
        { ref: "adminEditModal", attrs: { type: "small" } },
        [
          _c("template", { slot: "modalContent" }, [
            _c("div", { staticClass: "modal__main" }, [
              _c("p", { staticClass: "headline-large mg mg--b-1 black" }, [
                _vm._v(_vm._s(_vm.$t("depreciations.title")))
              ]),
              _c(
                "div",
                { staticClass: "grid mg mg--t-4" },
                [
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationDepreciationRepTypeCode",
                      col: 2,
                      icon: "house",
                      literal: "depreciations.table.repTypeCode",
                      value: _vm.depreciation.repTypeCode,
                      disabled: ""
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationDepreciationDescription",
                      col: 2,
                      icon: "house",
                      literal: "depreciations.table.description"
                    },
                    model: {
                      value: _vm.depreciation.description,
                      callback: function($$v) {
                        _vm.$set(_vm.depreciation, "description", $$v)
                      },
                      expression: "depreciation.description"
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationDepreciationYears",
                      col: 2,
                      icon: "house",
                      literal: "depreciations.table.years",
                      value: _vm.depreciation.years,
                      disabled: ""
                    }
                  }),
                  _c("ma-input-text", {
                    attrs: {
                      type: "text",
                      name: "adminReparationDepreciationDepreciationPerc",
                      col: 2,
                      icon: "house",
                      literal: "depreciations.table.depreciationPerc"
                    },
                    model: {
                      value: _vm.depreciation.depreciationPerc,
                      callback: function($$v) {
                        _vm.$set(_vm.depreciation, "depreciationPerc", $$v)
                      },
                      expression: "depreciation.depreciationPerc"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "modal--actions mg mg--t-5" }, [
              _c(
                "button",
                {
                  staticClass: "mainBlue mg mg--r-2",
                  on: { click: _vm.handleSave }
                },
                [_vm._v(_vm._s(_vm.$t("actions.save")))]
              ),
              _c(
                "button",
                {
                  staticClass: "secondaryBlue",
                  on: { click: _vm.handleCancel }
                },
                [_vm._v(_vm._s(_vm.$t("actions.cancel")))]
              )
            ])
          ])
        ],
        2
      ),
      _c("p", { staticClass: "mg mg--b-4 mg--t-4 headline-large" }, [
        _vm._v(_vm._s(_vm.$t("depreciations.title")))
      ]),
      _c("div", { staticClass: "grid" }, [
        _c(
          "div",
          { staticClass: "grid__cell-md-2" },
          [
            _c("ma-filters", {
              on: { "filter:change": _vm.handleFiltersChange }
            })
          ],
          1
        )
      ]),
      _c("table", { staticClass: "table" }, [
        _c("thead", [
          _c("tr", { staticClass: "bg-blueDark" }, [
            _c("th", { staticClass: "border-right", attrs: { width: "20%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("depreciations.table.repTypeCode")))
              ])
            ]),
            _c("th", { staticClass: "border-right", attrs: { width: "20%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("depreciations.table.description")))
              ])
            ]),
            _c("th", { staticClass: "border-right", attrs: { width: "20%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("depreciations.table.years")))
              ])
            ]),
            _c("th", { staticClass: "no--border", attrs: { width: "20%" } }, [
              _c("p", { staticClass: "text-medium white" }, [
                _vm._v(_vm._s(_vm.$t("depreciations.table.depreciationPerc")))
              ])
            ]),
            _vm.canEdit
              ? _c("th", {
                  staticClass: "border-right",
                  attrs: { width: "20px" }
                })
              : _vm._e()
          ])
        ]),
        _vm.hasData
          ? _c(
              "tbody",
              _vm._l(_vm.table, function(row) {
                return _vm.table
                  ? _c("tr", [
                      _c("td", [
                        _c("p", { staticClass: "text-medium black" }, [
                          _vm._v(_vm._s(row.rep_type_code))
                        ])
                      ]),
                      _c("td", { staticClass: "border-right" }, [
                        _c("p", { staticClass: "text-medium black" }, [
                          _vm._v(_vm._s(row.description))
                        ])
                      ]),
                      _c("td", { staticClass: "border-right" }, [
                        _c("p", { staticClass: "text-medium black" }, [
                          _vm._v(_vm._s(row.years))
                        ])
                      ]),
                      _c("td", { staticClass: "no--border" }, [
                        _c("p", { staticClass: "text-medium black" }, [
                          _vm._v(_vm._s(row.depreciation_perc))
                        ])
                      ]),
                      _vm.canEdit
                        ? _c(
                            "td",
                            { staticClass: "text-align--right" },
                            [
                              _c("svgicon", {
                                staticClass: "svg-icon-action",
                                attrs: {
                                  name: "edit",
                                  height: "16",
                                  widht: "16"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleEdit(
                                      row.rep_type_code,
                                      row.description,
                                      row.years,
                                      row.depreciation_perc
                                    )
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              }),
              0
            )
          : _vm._e()
      ]),
      _vm.hasData
        ? _c(
            "div",
            { staticClass: "grid grid--jc-bottom mg mg--t-4" },
            [
              _c("ma-paginator", {
                staticClass: "mg mg--t-2 mg--b-4",
                attrs: { current: _vm.currentPage, total: _vm.totalPages },
                on: {
                  "page:update": _vm.handlePageUpdate,
                  "page:set": _vm.handlePageSet
                }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.hasData
        ? _c("ma-empty", {
            attrs: {
              icon: "recherche",
              title: _vm.$t("common.noresults.short"),
              descr: _vm.$t("common.noresults.long")
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }